const CameraIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.03822 4.82275C2.78755 5.05724 2.64673 5.37526 2.64673 5.70687V11.3333C2.64673 11.6649 2.78755 11.983 3.03822 12.2174C3.28889 12.4519 3.62888 12.5837 3.98338 12.5837H13.3399C13.6944 12.5837 14.0344 12.4519 14.2851 12.2174C14.5358 11.983 14.6766 11.6649 14.6766 11.3333V5.70687C14.6766 5.37526 14.5358 5.05724 14.2851 4.82275C14.0344 4.58827 13.6944 4.45654 13.3399 4.45654H12.7184C12.4984 4.45657 12.2818 4.40581 12.0878 4.30875C11.8938 4.21169 11.7284 4.07134 11.6063 3.90015L11.0636 3.13745C10.9415 2.96626 10.7761 2.82591 10.5821 2.72885C10.3881 2.63179 10.1715 2.58102 9.95152 2.58105H7.37179C7.15178 2.58102 6.93517 2.63179 6.74118 2.72885C6.54718 2.82591 6.38179 2.96626 6.25969 3.13745L5.71701 3.90015C5.59491 4.07134 5.42953 4.21169 5.23553 4.30875C5.04153 4.40581 4.82492 4.45657 4.60492 4.45654H3.98338C3.62888 4.45654 3.28889 4.58827 3.03822 4.82275Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0794 9.53369C10.4555 9.18197 10.6667 8.70493 10.6667 8.20752C10.6667 7.71011 10.4555 7.23307 10.0794 6.88135C9.70344 6.52963 9.19347 6.33203 8.66171 6.33203C8.12996 6.33203 7.61999 6.52963 7.24398 6.88135C6.86798 7.23307 6.65674 7.71011 6.65674 8.20752C6.65674 8.70493 6.86798 9.18197 7.24398 9.53369C7.61999 9.88541 8.12996 10.083 8.66171 10.083C9.19347 10.083 9.70344 9.88541 10.0794 9.53369Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CameraIcon;
